import { render } from "./CanvasEditor.vue?vue&type=template&id=7dea54c5"
import script from "./CanvasEditor.vue?vue&type=script&lang=js"
export * from "./CanvasEditor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__